// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const shiinotic: PokeData = {
  "id": 756,
  "name": "shiinotic",
  "height": 10,
  "weight": 115,
  "base_experience": 142,
  "types": [
    PokeType.GRASS,
    PokeType.FAIRY
  ],
  "api_moves": [
    "absorb",
    "mega-drain",
    "sleep-powder",
    "confuse-ray",
    "dream-eater",
    "spore",
    "flash",
    "giga-drain",
    "moonlight",
    "ingrain",
    "astonish",
    "moonblast",
    "dazzling-gleam",
    "strength-sap",
    "spotlight"
  ],
  "moves": [
    "confuse-ray",
    "moonlight",
    "moonblast",
    "dazzling-gleam",
    "misty-terrain",
    "grassy-terrain",
    "synthesis",
    "solar-beam",
    "vine-whip",
    "leaf-tornado",
    "bullet-seed",
    "heal-bell",
    "flower-rush"
  ],
  "evolution_chain": {
    "id": 389,
    "item": null,
    "species": [
      {
        "name": "morelull",
        "order": 755,
        "types": [
          PokeType.GRASS,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "shiinotic",
        "order": 756,
        "types": [
          PokeType.GRASS,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 755,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 24,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 150,
    "speed": 60,
    "ability_power": 180
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
